export var isEqualDays = function isEqualDays(a, b) {
  if (a.isWorkingDay && b.isWorkingDay) {
    return a.callFrom === b.callFrom && a.callTo === b.callTo;
  }
  return a.isWorkingDay === b.isWorkingDay;
};